import { createFocusTrap } from "focus-trap";
import {
  add,
  contains,
  listen,
  qs,
  qsa,
  remove,
  toggle,
} from "@fluorescent/dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Delegate from "ftdomdelegate";

import { on } from "@/neon/events";

import {
  // addFilters,
  // removeFilters,
  // clearSort,
  // setSort,
  updateFilters,
} from "@/lib/collection/events";

import priceRange from "@/lib/collection/price-range";

const sel = {
  filter: "[data-filter-open]",
  flyouts: "[data-filter-flyout]",
  button: "[data-button]",
  wash: "[data-filter-wash]",
  tag: "[data-tag]",
  sort: "[data-sort]",
  close: "[data-close-icon]",
  form: "[data-filter-form-flyout]",
  priceRange: "[data-price-range]",
};

const selectors = {
  active: "active",
  checked: ":checked",
};

export default node => {
  const flyoutForm = qs(sel.form, node);
  if (!flyoutForm) return Function();

  const wash = qs(sel.wash, node);
  let focusTrap = null;

  let scrollPosition = 0;

  let range = null;
  let rangeContainer = qs(sel.priceRange, flyoutForm);

  if (rangeContainer) {
    range = priceRange(rangeContainer);
  }

  let delegate = new Delegate(node);

  delegate.on("click", sel.wash, clickWash);
  delegate.on("click", sel.button, clickButton);
  delegate.on("click", sel.close, clickWash);

  const events = [
    listen(qsa(sel.filter, node), "click", clickFlyoutTrigger),
    listen(node, "keydown", ({ keyCode }) => {
      if (keyCode === 27) clickWash();
    }),
  ];

  let collectionUpdatedHanlder = on("collection:updated", collectionUpdated);

  function collectionUpdated(evt) {
    range && range.unload();
    rangeContainer = qs(sel.priceRange, flyoutForm);

    if (rangeContainer) {
      range = priceRange(rangeContainer);
    }
  }

  function clickFlyoutTrigger(e) {
    e.preventDefault();
    const drawer = qs(`#${e.currentTarget.getAttribute("aria-controls")}`);

    if (drawer) {
      const close = qs(sel.close, drawer);
      close.setAttribute("aria-expanded", true);
      e.currentTarget.setAttribute("aria-expanded", true);

      add(wash, selectors.active);
      add(drawer, selectors.active);

      focusTrap = createFocusTrap(drawer, { allowOutsideClick: true });
      focusTrap.activate();

      disableBodyScroll(node, {
        hideBodyOverflow: true,
        allowTouchMove: el => {
          while (el && el !== document.body && el.id !== "main-content") {
            if (el.getAttribute("data-scroll-lock-ignore") !== null) {
              return true;
            }
            el = el.parentNode;
          }
        },
        reserveScrollBarGap: true,
      });

      scrollPosition = window.pageYOffset;
      document.body.style.top = `-${scrollPosition}px`;
      document.body.classList.add("scroll-lock");
    }
  }

  function clickWash(e) {
    e && e.preventDefault();

    focusTrap && focusTrap.deactivate();
    const flyouts = qsa(sel.flyouts, node);

    remove([...flyouts, wash], selectors.active);
    enableBodyScroll(node);
    document.body.classList.remove("scroll-lock");
    document.body.style.top = "";
    window.scrollTo(0, scrollPosition);

    flyouts.forEach(flyout => {
      const flyoutControls = qsa(`[aria-controls="${flyout.id}"]`);
      flyoutControls.forEach(control => {
        control.setAttribute("aria-expanded", false);
      });
    });
  }

  function clickButton(e) {
    e.preventDefault();
    const { button } = e.target.dataset;

    const scope = e.target.closest(sel.flyouts);

    if (button === "clear") {
      const inputs = qsa("[data-filter-item]", scope);
      inputs.forEach(input => {
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false;
        } else {
          input.value = "";
        }
      });
      removeRange();
    } else if (button === "apply") {
      updateFilters(flyoutForm);
      clickWash();
    }
  }

  function removeRange() {
    range && range.reset();
  }

  return () => {
    events.forEach(unsubscribe => unsubscribe());
    range && range.unload();
    delegate.off();
    collectionUpdatedHanlder();
  };
};
